import { Button } from '@progress/kendo-react-buttons';
import React, { useEffect } from 'react';
import { addMultiTabEventListener, getTabId, getTabs, initMultiTabListener, supportsSharedWorker } from '../../multi-tab/multi-tab';
import { LoginFrame } from '../features/login/LoginFrame';

export function MultiTabGuard(props: { children?: React.ReactNode }) {
    const [tabs, setTabs] = React.useState<string[]>(getTabs);
    const canDisplayContent = tabs[0] === getTabId(); // || import.meta.env.DEV; if you want to bypass this in dev uncomment this line
    const multiTabStateLoaded = tabs.length > 0;

    useEffect(() => {
        initMultiTabListener();
        return addMultiTabEventListener(setTabs).unsubscribe;
    }, []);

    useEffect(() => {
        if (!supportsSharedWorker) {
            return;
        }

        if (!canDisplayContent && multiTabStateLoaded) {
            // Temporarily force light theme
            document.documentElement.dataset['isDark'] = 'false';
        }
    }, [canDisplayContent, multiTabStateLoaded]);

    if (!supportsSharedWorker) {
        return props.children;
    }

    // Wait for multi tab state to load
    if (!multiTabStateLoaded) {
        return <></>;
    }

    if (canDisplayContent) {
        return props.children;
    }

    return (
        <LoginFrame>
            <div>Flight Explorer is open in another tab.</div>
            <div>Please use FE in the other tab, or close that tab before proceeding here.</div>
            <Button className="mt-2" themeColor="primary" onClick={() => location.reload()}>
                Refresh
            </Button>
        </LoginFrame>
    );
}
